import ScwPatentTypes from 'store/actionTypes/scwPatent'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  filter: {},
  content: {},
  languages: {}
}

const scwPatent = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case ScwPatentTypes.GET_SCW_PATENTS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case ScwPatentTypes.GET_SCW_PATENT_DETAIL_SUCCESS:
      return {
        ...state,
        current: payload?.scwPatent
      }
    case ScwPatentTypes.GET_SCW_PATENT_CONTENT_SUCCESS:
      return {
        ...state,
        content: payload?.product || {}
      }
    case ScwPatentTypes.GET_SCW_PATENT_CONTENT_FAILED:
      return {
        ...state,
        content: {}
      }
    case ScwPatentTypes.UPDATE_FILTER_SCW_PATENT_SUCCESS:
      return { ...state, filter: payload }
    case ScwPatentTypes.UPDATE_SCW_PATENT_SELECTED_LANGUAGES_SUCCESS:
      return {
        ...state,
        languages: {
          ...state.languages,
          [payload?.id]: payload?.languageId
        }
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default scwPatent
